<template>
  <article class="admin-exclusive-card" :class="{ 'admin-exclusive-card--inactive': !isActive }">
    <div class="admin-exclusive-card__position">
      <AdminExclusiveProjectOrderControls
        :position="displayPosition"
        :total="total"
        :project-name="projectName"
        :disabled="busy"
        @move-up="$emit('move-up', item)"
        @move-down="$emit('move-down', item)"
      />
    </div>

    <div class="admin-exclusive-card__cover-wrap">
      <img
        class="admin-exclusive-card__cover"
        :src="cover"
        :alt="`Capa de ${projectName}`"
        loading="lazy"
        @error="onImageError"
      />
    </div>

    <div class="admin-exclusive-card__body">
      <div class="admin-exclusive-card__header">
        <div class="admin-exclusive-card__title-group">
          <strong class="admin-exclusive-card__title">{{ projectName }}</strong>
          <span class="admin-exclusive-card__meta">
            ID {{ projectId || "-" }}
            <span v-if="projectStatus">- {{ projectStatus }}</span>
          </span>
        </div>

        <v-chip small :color="isActive ? '#2e7d32' : '#616161'" dark class="admin-exclusive-card__status">
          {{ isActive ? "Ativo" : "Inativo" }}
        </v-chip>
      </div>

      <div class="admin-exclusive-card__actions">
        <v-switch
          :input-value="isActive"
          :disabled="busy"
          color="var(--zinnes-primary)"
          hide-details
          inset
          class="admin-exclusive-card__switch"
          :aria-label="`${isActive ? 'Desativar' : 'Ativar'} ${projectName}`"
          @change="$emit('toggle-active', item, $event)"
        />

        <v-spacer />

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              class="admin-exclusive-icon-btn admin-exclusive-icon-btn--danger"
              :disabled="busy"
              :aria-label="`Remover ${projectName} dos exclusivos`"
              v-bind="attrs"
              v-on="on"
              @click="$emit('remove', item)"
            >
              <v-icon>mdi-delete-outline</v-icon>
            </v-btn>
          </template>
          <span>Remover dos exclusivos</span>
        </v-tooltip>
      </div>
    </div>
  </article>
</template>

<script>
import { HOME_PROJECT_FALLBACK, imageWithFallback, setImageFallback } from "@/utils/homeImageFallbacks";
import AdminExclusiveProjectOrderControls from "./AdminExclusiveProjectOrderControls.vue";

export default {
  name: "AdminExclusiveProjectCard",
  components: { AdminExclusiveProjectOrderControls },
  props: {
    item: { type: Object, required: true },
    index: { type: Number, required: true },
    total: { type: Number, required: true },
    busy: { type: Boolean, default: false },
  },
  computed: {
    project() {
      return this.item.project || this.item;
    },
    displayPosition() {
      return Number(this.item.position || this.index + 1);
    },
    projectId() {
      return this.project.id || this.item.project_id;
    },
    projectName() {
      return this.project.name || this.project.nome || "Obra sem titulo";
    },
    cover() {
      return imageWithFallback(this.project.project_thumb || this.project.cover || this.project.thumb, HOME_PROJECT_FALLBACK);
    },
    isActive() {
      return this.item.active !== false && this.item.active !== 0;
    },
    projectStatus() {
      if (this.project.completed === true || this.project.completed === 1) return "Finalizada";
      if (this.project.status) return this.project.status;
      if (this.project.published === false || this.project.published === 0) return "Nao publicada";
      return "";
    },
  },
  methods: {
    onImageError(event) {
      setImageFallback(event, HOME_PROJECT_FALLBACK);
    },
  },
};
</script>

<style src="../../../styles/home-page/admin.css"></style>
